import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';

const VaixSearchInput = ({
  value,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  onClick,
  onClear,
  placeholder,
  inputType,
  disabled,
  name,
  autoComplete,
  className,
  iconName,
  closeBtnIconName,
}) => {
  return (
    <div className={ className }>
      <Icon iconName={ iconName }/>
      <input
        type={ inputType }
        name={ name }
        value={ value }
        onChange={ onChange }
        onKeyDown={ onKeyDown }
        onFocus={ onFocus }
        onBlur={ onBlur }
        onClick={ onClick }
        placeholder={ placeholder }
        disabled={ disabled }
        autoComplete={ autoComplete }
      />
      { value && value.length > 0 ? (
        <Icon className="vaix-search__input" iconName={ closeBtnIconName } onClick={ onClear } />
      ) : null }
    </div>
  );
};

VaixSearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onClear: PropTypes.func,
  placeholder: PropTypes.string,
  inputType: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  iconName: PropTypes.string,
  closeBtnIconName: PropTypes.string
};

VaixSearchInput.defaultProps = {
  value: '',
  onChange: () => {},
  onKeyDown: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onClick: undefined,
  onClear: undefined,
  inputType: 'text',
  disabled: false,
  name: undefined,
  autoComplete: 'off',
  className: 'vaix-search__header',
  iconName: 'svgVaixSearch',
  closeBtnIconName: ''
};

export default VaixSearchInput;
